import * as d3 from 'd3';
import { NumberFormat } from './NumberFormat';

export class NumberFormatHelper {
    format(interval: number): NumberFormat {
        const result = new NumberFormat();
        const logDelta = Math.log(interval) / Math.LN10;
        const og = Math.pow(10, Math.floor(logDelta));
        if (og <= 1) {
            if (interval < 5 * og) {
                result.format = `.${(Math.abs(logDelta) + 1).toFixed()}f`;
            } else {
                result.format = `.${Math.floor(Math.abs(logDelta)) + (og === 1 ? 0 : 1)}f`;
            }
        }
        return result;
    }

    static getFormat(min: number, max: number): (n: number) => string {
        return d3.format(NumberFormatHelper.getFormatString(min, max));
    }

    static getFormatString(min: number, max: number): string {
        let stringFormat = 'g';
        if (max - min < 1e-3) {
            stringFormat = '.2e';
        } else if (min < -1e4 || max > 1e4) {
            stringFormat = '.2s';
        } else if (max - min < 1) {
            stringFormat = '.2f';
        } else if (max > 1e3 || min < -1e3) {
            stringFormat = '.0f';
        } else if (max > 1e2 || min < -1e2) {
            stringFormat = '.2f';
        }
        return stringFormat;
    }
}